import { render, staticRenderFns } from "./PreviewPicture.vue?vue&type=template&id=654cf71b&scoped=true&"
import script from "./PreviewPicture.vue?vue&type=script&lang=js&"
export * from "./PreviewPicture.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPicture.vue?vue&type=style&index=0&id=654cf71b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654cf71b",
  null
  
)

export default component.exports